import {Component, OnInit, Input, Output, EventEmitter, OnDestroy, OnChanges, ViewChild, ElementRef} from '@angular/core';

import {FormGroup} from '@angular/forms';
import {Subscription, Subject} from 'rxjs';
import { map } from 'rxjs/operators';
import isRequired from '../../helpers/decorator';
import { ApiResponse } from '../../models/api-response.model';
import { LookupBase } from '../../models/lookup.base.model';
import { LookupService } from '../../services/lookup.service';
import { LookupsService } from '../../services/lookups-service';
import * as $ from 'jquery';
import 'select2';
@Component({
    selector: 'app-drop-down',
    templateUrl: './drop-down.component.html',
    styleUrls: ['./drop-down.component.scss']
})
export class DropDownComponent implements OnInit, OnChanges, OnDestroy {
  @Input() skipCaching: boolean = false;
  @isRequired()
  @Input() fg: FormGroup
  @isRequired()
  @Input() fcn: string
  @Input() url: string
  @Input() initialData: Array<LookupBase>
  @Input() title: string
  @Input() className: string
  @Input() hasDefaultValue: boolean
  @Input() disableFirstValue: boolean
  @Output() onDropDownValueChanged: EventEmitter<any> = new EventEmitter()
  @Output() onDropDownChanged: EventEmitter<any> = new EventEmitter()
  @Input() valueName: string
  subscribe$: Subject<any>
  subscription: Subscription;
  data: Array<LookupBase> = [];
  //@ViewChild('mySelect', { static: true }) mySelect: ElementRef;
  constructor(private lookupService: LookupService) {
  }
  ngOnChanges() {
    if (this.initialData) {
      this.data = this.initialData
    }
    if (this.url) {
      // this.fetchUrl()
    }
  }
  ngOnInit() {
    //this.initSelect2();
    this.valueName = this.valueName ? this.valueName : 'name'
    this.skipCaching = this.skipCaching
    this.observe()
    if (this.url) {
      this.fetchUrl();
    } else if (this.initialData) {
      this.data = this.initialData
    }
  }
  //private initSelect2() {
  //  setTimeout(() => {
  //    if (this.mySelect) {
  //      $(this.mySelect.nativeElement).select2({ dropdownAutoWidth: true })
  //        .on('change', (event) => {
  //          const value = $(event.target).val();
  //          this.fg.get(this.fcn).setValue(value === '0: null' ? null : value);
  //        })
  //        .trigger('change');
  //    }
  //  }, 1000);
  //}
  fetchUrl() {
    this.lookupService.getLookup(this.url)
      .pipe(map((res): Array<LookupBase> => {
        !this.skipCaching && this.lookupService.saveLookup(this.url, res)
        return (res.value).map((obj) => {
          return {
            id: obj.id,
            name: obj[this.valueName],
            [this.valueName]: obj[this.valueName],
            systemValue: obj.systemValue,
            disabled: obj.disabled
          }
        })
      }))
      .subscribe(_res => {
        this.data = _res as Array<LookupBase>
        this.onChange(this.fg.get(this.fcn).value)
      })
  }
  observe() {
    this.subscription = this.fg.get(this.fcn).valueChanges
      .subscribe(_res => {
        this.fg.get(this.fcn).updateValueAndValidity({ emitEvent: false })
        this.onChange(_res)
      })
  }
  onChange(id) {
    let value = this.data.find(x => x.id == id)
    value && this.onDropDownValueChanged.emit(value)
  }
  dropDownChanged(id) {
    let value = this.data.find(x => x.id == event.target['value'])
    this.onDropDownChanged.emit(value)
  }
  ngOnDestroy() {
    this.subscription && this.subscription.unsubscribe()
  }
}
